// Array for holding GSObjects. Has build in serialize and deserialize capabilities.
// Expects a GSO parent (can be null) and a item type.
export default class GSObjectArray extends Array {
    constructor(gsoParent, type) {
        super();

        this.indexKey = 'index';
        this.itemType = type;
        this._gsoParent = gsoParent;
    }

    // Disables all items in the array and enabled the item that matches the index parameter.
    setActive(index, createVisuals, createBody) {
        if (!this[index]) throw new Error('Unknown index.');
        for (let i = 0; i < this.length; i++) {
            if (i !== index) {
                this[i].disable();
            }
        }
        this[index].enable();
        if (createVisuals) this[index]._gsoCreateVisuals();
        if (createBody) this[index]._gsoCreateBody();
        return this[index];
    }

    // Serialize this object and returns a JSON object. Array null objects are removed and items are indexed.
    serialize() {
        // Clean the array
        const newValues = this.filter(el => {
            return el != null;
        });
        this.splice(0, this.length);
        for (var i = 0; i < newValues.length; i++) {
            this.push(newValues[i]);
        }
        // Index items in the array
        for (var i = 0; i < this.length; i++) {
            if (this[i]) {
                this[i][this.indexKey] = i;
            }
        }
        const serialized = [];
        for (var i = 0; i < this.length; i++) {
            serialized.push(this[i].serialize());
        }
        return serialized;
    }

    // Deserialize the given JSON object and replace this object with those values. Fills the array with "itemType : GSObject" items.
    deserialize(json) {
        this.destroy();
        for (let i = 0; i < json.length; i++) {
            const newItem = new this.itemType(this._gsoParent);
            newItem.deserialize(json[i]);
            this.push(newItem);
        }
    }

    destroy() {
        for (let i = 0; i < this.length; i++) {
            if (this[i]) this[i].destroy();
        }
        this.splice(0, this.length);
    }
}
